import { call, options, params } from './helpers';

export const getTags = (payload) => call(`/beta/tags${params(payload)}`);

export const updateTag = (payload) =>
	call(`/beta/tags`, options(payload, 'PUT'));
export const deleteTag = (payload) =>
	call(`/beta/tags`, options(payload, 'DELETE'));
export const addTag = (payload) => call(`/beta/tags`, options(payload, 'POST'));
